import { APIEndpoint } from "./axios";
import { onDownloadCSVFile, onDownloadXlsFile } from "./commonFunctions";

let timeout;
const MAX_RETRIES = 10;

const checkDownloadStatus = (jobId, onDownloadSuccess, onDownloadFailure, downloadExcel = false) => {
  let retryCount = 0;

  // Provide default callbacks if not provided
  const handleSuccess = onDownloadSuccess && typeof onDownloadSuccess === 'function' 
    ? onDownloadSuccess 
    : () => console.log('Download completed successfully');
  
  const handleFailure = onDownloadFailure && typeof onDownloadFailure === 'function'
    ? onDownloadFailure
    : (error) => console.error('Download failed:', error);

  const checkStatus = async () => {
    await APIEndpoint.get(`downloads/status/${jobId}`)
      .then((resp) => {
        if (resp.status === "completed") {
          clearTimeout(timeout);

          if (downloadExcel){
            onDownloadXlsFile(
              `downloads/analytics/${resp.fileName}.xlsx`,
              resp.fileName
            );
            handleSuccess(resp);
            return;
          }
          onDownloadCSVFile(
            `downloads/analytics/${resp.fileName}${resp.fileExtension}`,
            resp.fileName
          );
          handleSuccess(resp);
        } else {
          if (retryCount >= MAX_RETRIES) {
            clearTimeout(timeout);
            handleFailure(
              new Error(`Download status check failed after ${MAX_RETRIES} attempts`)
            );
            return;
          }
          retryCount++;
          timeout = setTimeout(() => {
            checkStatus();
          }, 5000);
        }
      })
      .catch((error) => {
        clearTimeout(timeout);
        handleFailure(error);
      });
  };

  checkStatus();
};

export default checkDownloadStatus;
